import { render, staticRenderFns } from "./SendBox.vue?vue&type=template&id=9d9d87f6"
import script from "./SendBox.vue?vue&type=script&lang=js"
export * from "./SendBox.vue?vue&type=script&lang=js"
import style0 from "./SendBox.vue?vue&type=style&index=0&id=9d9d87f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports